// Customer portal helpers — token storage, REST + WebSocket
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws");

const TOKEN_KEY = "lh2o_portal_token";

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setPortalToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function clearPortalToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const portalApi = axios.create({ baseURL: PORTAL_API });
portalApi.interceptors.request.use((config) => {
  const token = getPortalToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function buildPortalWsUrl(token) {
  return `${WS_BASE}/api/ws/portal/${encodeURIComponent(token)}`;
}

export function buildAdminWsUrl(jwt) {
  return `${WS_BASE}/api/ws/admin?token=${encodeURIComponent(jwt)}`;
}

// Soft chime (Web Audio API — no asset required)
export function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.connect(g);
    g.connect(ctx.destination);
    o.frequency.setValueAtTime(880, ctx.currentTime);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + 0.02);
    o.start();
    o.frequency.exponentialRampToValueAtTime(523, ctx.currentTime + 0.18);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.28);
    o.stop(ctx.currentTime + 0.32);
    setTimeout(() => ctx.close().catch(() => {}), 400);
  } catch (_) {
    /* no-op */
  }
}
